import React from "react";
import { Navigate } from "react-router-dom";
import { getUserDetails } from "./utils/sessionUtils";
import { useSelector } from "react-redux";
const findFormName = (data, targetFormName) => {
  let foundFormName = false;

  data.forEach((subArray) => {
    const foundItem = subArray.find((item) => item.formName === targetFormName);
    if (foundItem) {
      foundFormName = foundItem.formName;
      return; // Exit the forEach loop early if a match is found
    }
  });

  return foundFormName;
};
const ProtectedRoute = ({ routeName, element: Component, ...rest }) => {
  const menuData = useSelector((state) => {
    if (routeName === "home") {
      return [
        {
          formName: "home",
        },
      ];
    } else {
      return state.userDetails.userMenu;
    }
  });
  const isAuthenticated = getUserDetails();
  // If user is not authenticated, navigate to login
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (
    routeName === "PrintReceipt" ||
    routeName === "profile" ||
    routeName === "CashChallan" ||
    routeName === "edc-receipt" ||
    routeName === "SearchPropertyToGenReceipt"
  ) {
    return <Component {...rest} />;
  }

  // If route is not "home" and menuData is provided, check access
  if (routeName !== "home" && menuData) {
    const isUserHasRouteAccess = findFormName(menuData, routeName);

    // If user has access to the route, render the component
    if (isUserHasRouteAccess) {
      return <Component {...rest} />;
    } else {
      // If user doesn't have access, navigate to unauthorized
      return <Navigate to="/unauthorized" />;
    }
  }

  // If route is "home" or no menuData provided, render the component
  return <Component {...rest} />;
};

export default ProtectedRoute;
